import { Sanity$ProductPage } from '@otovo/shared/types/sanityTypes';
import SanityImage from '@otovo/shared/components/Sanity/SanityImage';
import Button from '@otovo/shared/rainbow/Button/Button';
import cx from 'classnames';
import ArrowDown from '@otovo/shared/images/icons/arrow-down.svg';
import { useRouter } from 'next/router';
import { getEstimatedProductPagePadding } from '@otovo/shared/components/NotificationBanner/estimateRequiredPadding';
import HeroHeading from '../../SanityLandingPage/components/HeroSection/HeroHeading';
import HeroLead from '../../SanityLandingPage/components/HeroSection/HeroLead';

type Props = {
  page: Sanity$ProductPage;
  isBannerShown: boolean;
};

const ProductHeroSection = ({ page, isBannerShown }: Props) => {
  const padding = getEstimatedProductPagePadding(
    isBannerShown ? page.banner : undefined,
  );

  const router = useRouter();
  return (
    <>
      <div
        className={cx(
          'relative grid',
          'lg:grid-cols-[_1fr_400px_400px_400px_1fr]',
        )}
      >
        <div
          className={cx(
            'col-span-full w-full',
            'max-w-7xl transform lg:absolute lg:col-span-2 lg:col-start-2 lg:translate-y-10 lg:p-8 xl:p-0',
            padding,
          )}
        >
          <div className="w-full bg-white p-8 md:p-12 lg:rounded-2xl">
            <HeroHeading>{page.headline}</HeroHeading>
            {!!page.lead && <HeroLead>{page.lead}</HeroLead>}
            {page.productHeroCtaButton && (
              <Button
                className="mt-4 flex w-full items-center justify-center gap-3 py-4 font-normal md:text-[20px]"
                variant="peach"
                onClick={() => router.push('#content-row')}
              >
                {page.productHeroCtaButton} <ArrowDown />
              </Button>
            )}
          </div>
        </div>
        <SanityImage
          image={page.mainImage}
          className="col-span-full w-full rounded-none object-cover"
          priority
        />
      </div>
    </>
  );
};

export default ProductHeroSection;
